module.exports = __webpack_public_path__ + "img/strength-2.a52bace5.png";